import ButtonContainedMixin from './mixins/button-contained-mixin.js';
import ButtonLargeMixin from './mixins/button-large-mixin.js';
import TpButton from './tp-button.js';

export default class TpButtonContainedLarge extends
  ButtonLargeMixin(
  ButtonContainedMixin(
    TpButton
  )) {}
